import React, { useState, Children } from 'react';
import { useFormContext } from 'react-hook-form';
import { PlusIcon, TrashIcon } from 'lucide-react';
const SpouseAndFamily = () => {
  const {
    register,
    formState: {
      errors
    },
    watch
  } = useFormContext();
  const [children, setChildren] = useState([{
    id: 1,
    name: '',
    age: ''
  }]);
  const [grandchildren, setGrandchildren] = useState([{
    id: 1,
    name: '',
    age: '',
    parent: ''
  }]);
  const maritalStatus = watch('clientInfo.maritalStatus');
  const addChild = () => {
    const newId = children.length > 0 ? Math.max(...children.map(c => c.id)) + 1 : 1;
    setChildren([...children, {
      id: newId,
      name: '',
      age: ''
    }]);
  };
  const removeChild = (id: number) => {
    setChildren(children.filter(child => child.id !== id));
  };
  const addGrandchild = () => {
    const newId = grandchildren.length > 0 ? Math.max(...grandchildren.map(g => g.id)) + 1 : 1;
    setGrandchildren([...grandchildren, {
      id: newId,
      name: '',
      age: '',
      parent: ''
    }]);
  };
  const removeGrandchild = (id: number) => {
    setGrandchildren(grandchildren.filter(grandchild => grandchild.id !== id));
  };
  return <div className="space-y-8" data-id="element-930" data-mp="33wqyri9scy4u">
      <div className="bg-slate-50 p-4 rounded-lg border border-slate-200 mb-6" data-id="element-931" data-mp="33xsbdr6g9soo">
        <p className="text-slate-700" data-id="element-932" data-mp="38usim5f1d1hd">
          Please provide information about your spouse, children, and other
          family members.
        </p>
      </div>

      {/* Spouse Information */}
      {(maritalStatus === 'married' || maritalStatus === 'commonLaw') && <div className="space-y-6" data-id="element-933" data-mp="3mts3d1zfgw89">
          <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-934" data-mp="3mspeezlo13uz">
            Spouse Information
          </h3>

          <div data-id="element-935" data-mp="1sg92bi66uvi7">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-936" data-mp="1shtux28y04df">
              Spouse's Name
              <span className="text-red-500 ml-1" data-id="element-937" data-mp="2vsr9baa1ymde">*</span>
            </label>
            <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter your spouse's full legal name" {...register('spouseInfo.name')} data-id="element-938" data-mp="2qt4w30u8564l" />
          </div>

          <div data-id="element-939" data-mp="3epsiz8ejxano">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-940" data-mp="3ep96w8bl1ghk">
              Spouse's Age
            </label>
            <input type="number" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter your spouse's age" {...register('spouseInfo.age')} data-id="element-941" data-mp="39r7euxw6i6ty" />
          </div>
        </div>}

      {/* Previous Marriages */}
      <div className="space-y-4" data-id="element-942" data-mp="3siqh32idpgux">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-943" data-mp="3sjjnu3hc86d2">
          Previous Marriages
        </h3>

        <div data-id="element-944" data-mp="kxfshrt7pjwf">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-945" data-mp="kx7iq8sdyupg">
            Have you been previously married?
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-946" data-mp="6wwnktk1mtyh">
            <label className="inline-flex items-center" data-id="element-947" data-mp="az00lmmd26lv">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('previousMarriages.exists')} data-id="element-948" data-mp="axgkpx4m9xkm" />
              <span className="ml-2" data-id="element-949" data-mp="20oe9wsj1uz8">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-950" data-mp="3jgeb9pz3gz09">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('previousMarriages.exists')} data-id="element-951" data-mp="3odwo3rg8fydj" />
              <span className="ml-2" data-id="element-952" data-mp="3fdzwpi2gkles">No</span>
            </label>
          </div>

          {watch('previousMarriages.exists') === 'true' && <div data-id="element-953" data-mp="37c0kazxyxfk6">
              <label className="block text-navy-800 font-medium mb-2" data-id="element-954" data-mp="37emr2xd1br1c">
                Name of ex-spouse
              </label>
              <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter name of ex-spouse" {...register('previousMarriages.exSpouseName')} data-id="element-955" data-mp="2xmh1fua99lpb" />
            </div>}
        </div>
      </div>

      {/* Domestic Contracts */}
      <div className="space-y-4" data-id="element-956" data-mp="2enlacrtp1nfp">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-957" data-mp="2eomx3tk2nyd9">
          Domestic Contracts
        </h3>

        <div data-id="element-958" data-mp="2aow0h97v6o0t">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-959" data-mp="cwhwzusf5urg">
            Do you have any domestic contracts? (e.g., prenuptial agreement,
            separation agreement)
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-960" data-mp="1qst01sw5pvhl">
            <label className="inline-flex items-center" data-id="element-961" data-mp="1qsj8w1zdliab">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('domesticContracts.exists')} data-id="element-962" data-mp="1vrcqo6lp3vga" />
              <span className="ml-2" data-id="element-963" data-mp="24j4vo1ryacdh">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-964" data-mp="17u6y6bstg0cm">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('domesticContracts.exists')} data-id="element-965" data-mp="17vrti3myfnbj" />
              <span className="ml-2" data-id="element-966" data-mp="1gwq0musowayc">No</span>
            </label>
          </div>
        </div>
      </div>

      {/* Support Obligations */}
      <div className="space-y-4" data-id="element-967" data-mp="2saa9yci8swlo">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-968" data-mp="2s98wk1dr7y0s">
          Support Obligations
        </h3>

        <div data-id="element-969" data-mp="2xaokc17bgimv">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-970" data-mp="x6c7uu21kuib">
            Do you have any support obligations? (e.g., child support, spousal
            support)
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-971" data-mp="t7d9jsatfvzu">
            <label className="inline-flex items-center" data-id="element-972" data-mp="1749w3hjwirax">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('supportObligations.exists')} data-id="element-973" data-mp="12571kr1js3h7" />
              <span className="ml-2" data-id="element-974" data-mp="9ht1wl6gstte">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-975" data-mp="o5xmjup2vfet">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('supportObligations.exists')} data-id="element-976" data-mp="o7igbi3kiubm" />
              <span className="ml-2" data-id="element-977" data-mp="3rsxx5ic7fci7">No</span>
            </label>
          </div>

          {watch('supportObligations.exists') === 'true' && <div data-id="element-978" data-mp="22ddfzlp982h2">
              <label className="block text-navy-800 font-medium mb-2" data-id="element-979" data-mp="22cu7swpeosg8">
                Details of support obligations
              </label>
              <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="Enter details of your support obligations" {...register('supportObligations.details')} data-id="element-980" data-mp="276or3z13n5es" />
            </div>}
        </div>
      </div>

      {/* Children */}
      <div className="space-y-4" data-id="element-981" data-mp="2q13s1u6z1859">
        <div className="flex justify-between items-center" data-id="element-982" data-mp="2c487b4hcxs9d">
          <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-983" data-mp="2c61c0e8eu2eq">
            Children
          </h3>
          <button type="button" onClick={addChild} className="flex items-center text-sm text-navy-700 hover:text-navy-900" data-id="element-984" data-mp="10o09thgs974k">
            <PlusIcon size={16} className="mr-1" data-id="element-985" data-mp="15l9wipcsf4op" />
            Add Child
          </button>
        </div>

        {children.map((child, index) => <div key={child.id} className="p-4 bg-slate-50 rounded-md" data-id="element-986" data-mp="1sb1ml7avt5fj" data-mpi={index}>
            <div className="flex justify-between items-center mb-3" data-id="element-987" data-mp="1ncrpus9idwrt">
              <h4 className="font-medium" data-id="element-988" data-mp="1nf48l7n3cb5x">Child {index + 1}</h4>
              {children.length > 1 && <button type="button" onClick={() => removeChild(child.id)} className="text-red-500 hover:text-red-700" data-id="element-989" data-mp="1ig9om2de0gk8">
                  <TrashIcon size={16} data-id="element-990" data-mp="2b4p0wh54wkrv" />
                </button>}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-991" data-mp="269sw0gesu2xc">
              <div data-id="element-992" data-mp="21bzui0ofxx3e">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-993" data-mp="21cj1wnggt336">
                  Name
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter child's name" {...register(`children.${index}.name`)} data-id="element-994" data-mp="2ytzsb80lh2tc" />
              </div>
              <div data-id="element-995" data-mp="3baj2fd1xwzlj">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-996" data-mp="3b9zlnzo10h93">
                  Age
                </label>
                <input type="number" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter child's age" {...register(`children.${index}.age`)} data-id="element-997" data-mp="3gb6ttzu2ziga" />
              </div>
            </div>
          </div>)}

        {/* Note about treating others like children */}
        <div className="bg-amber-50 p-4 rounded-md border border-amber-200" data-id="element-998" data-mp="7u24v7vd0b1s">
          <p className="text-sm text-amber-800" data-id="element-999" data-mp="7rzakbn6bvr9">
            <strong data-id="element-1000" data-mp="buvss18sxpuo">Note:</strong> If there are any others that you treat like a
            child and want to be included in this category, please specifically
            advise in the text box below.
          </p>
        </div>
        <div data-id="element-1001" data-mp="2y4osy2bdh68g">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-1002" data-mp="2y22padrlravi">
            Additional persons treated as children
          </label>
          <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="Please list any other persons you treat like a child and wish to include" {...register('additionalChildLikePersons')} data-id="element-1003" data-mp="37ugszc28qrkb" />
        </div>
      </div>

      {/* Grandchildren */}
      <div className="space-y-4" data-id="element-1004" data-mp="3qskpn70xyy58">
        <div className="flex justify-between items-center" data-id="element-1005" data-mp="3qrrs8wnvhkzr">
          <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-1006" data-mp="1rfp253kqtsd4">
            Grandchildren
          </h3>
          <button type="button" onClick={addGrandchild} className="flex items-center text-sm text-navy-700 hover:text-navy-900" data-id="element-1007" data-mp="1wfuw4qehjqyd">
            <PlusIcon size={16} className="mr-1" data-id="element-1008" data-mp="1k40ui02q1n7w" />
            Add Grandchild
          </button>
        </div>

        {grandchildren.map((grandchild, index) => <div key={grandchild.id} className="p-4 bg-slate-50 rounded-md" data-id="element-1009" data-mp="1f3d6ln9shmhw" data-mpi={index}>
            <div className="flex justify-between items-center mb-3" data-id="element-1010" data-mp="1a7xt4wfp1sm0">
              <h4 className="font-medium" data-id="element-1011" data-mp="27ueovx8s3y5n">Grandchild {index + 1}</h4>
              {grandchildren.length > 1 && <button type="button" onClick={() => removeGrandchild(grandchild.id)} className="text-red-500 hover:text-red-700" data-id="element-1012" data-mp="22wd6zfn3a4vr">
                  <TrashIcon size={16} data-id="element-1013" data-mp="1sw2trv120xgl" />
                </button>}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1014" data-mp="mhldt0i4ctle">
              <div data-id="element-1015" data-mp="hh7gace5921m">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-1016" data-mp="hgnuulpabviu">
                  Name
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter grandchild's name" {...register(`grandchildren.${index}.name`)} data-id="element-1017" data-mp="35o5vdf9w9t9v" />
              </div>
              <div data-id="element-1018" data-mp="2lzop5a0hsbxl">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-1019" data-mp="2lzezxon9u8sy">
                  Age
                </label>
                <input type="number" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter grandchild's age" {...register(`grandchildren.${index}.age`)} data-id="element-1020" data-mp="2qr6tm81q4unb" />
              </div>
              <div data-id="element-1021" data-mp="2335euhdychzg">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-1022" data-mp="27zmd44ev8cq9">
                  Parent (Your Child)
                </label>
                <select className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" {...register(`grandchildren.${index}.parent`)} data-id="element-1023" data-mp="1oevkspxdylv7">
                  <option value="" data-id="element-1024" data-mp="1y9xc9sf4w00y">Select parent</option>
                  {children.map(child => <option key={child.id} value={child.id} data-id="element-1025" data-mp="27cyg1mgj1f1g">
                      {watch(`children.${children.findIndex(c => c.id === child.id)}.name`) || `Child ${child.id}`}
                    </option>)}
                </select>
              </div>
            </div>
          </div>)}
      </div>

      {/* Deceased Children */}
      <div className="space-y-4" data-id="element-1026" data-mp="2r0yww91linrv">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-1027" data-mp="2r20gj1wogil7">
          Deceased Children
        </h3>

        <div data-id="element-1028" data-mp="2m3p72saaoa3i">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-1029" data-mp="2m01bzop7bfmo">
            Do you have any deceased children?
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-1030" data-mp="ods3azzfqtvn">
            <label className="inline-flex items-center" data-id="element-1031" data-mp="oc7dfno2fz44">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('deceasedChildren.exists')} data-id="element-1032" data-mp="t61uejcadzzi" />
              <span className="ml-2" data-id="element-1033" data-mp="hw4zjaafmtc">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-1034" data-mp="5ewey5a9d9pq">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('deceasedChildren.exists')} data-id="element-1035" data-mp="5him43t8ln7f" />
              <span className="ml-2" data-id="element-1036" data-mp="1lto7ci7emgz1">No</span>
            </label>
          </div>

          {watch('deceasedChildren.exists') === 'true' && <div data-id="element-1037" data-mp="1qrpqf34tygai">
              <label className="block text-navy-800 font-medium mb-2" data-id="element-1038" data-mp="1qr7jnckjkjoc">
                Names of deceased children
              </label>
              <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="Enter names of deceased children" {...register('deceasedChildren.names')} data-id="element-1039" data-mp="36bq9c6pqufjq" />
            </div>}
        </div>
      </div>
    </div>;
};
export default SpouseAndFamily;